import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const DataProcessing = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Data Processing Agreement</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection text-center wow animate__fadeInDown">
              <h2>Data Processing Agreement</h2>
            </div>
            <p>
              <strong>Between</strong>
            </p>
            <p>
              <strong>RightO Services Private Ltd.</strong>, a company
              incorporated under the laws of India having its registered office
              at 52/1 Park Road, Dehradun - 248001, India, trading as{" "}
              <strong>Hourlee</strong> (hereinafter &ldquo;
              <strong>Hourlee</strong>&rdquo;, &ldquo;
              <strong>Data Fiduciary</strong>&rdquo;, or &ldquo;
              <strong>Controller</strong>&rdquo;);
            </p>
            <p>and</p>
            <p>
              The <strong>Employer</strong> (legal name and address set out in
              the Account), who uses the Hourlee Platform to post jobs and
              engage Workers (hereinafter &ldquo;<strong>Employer</strong>
              &rdquo; or &ldquo;<strong>Processor</strong>&rdquo;).
            </p>
            <p>
              <strong>Effective Date:</strong> The effective date shall be the
              date of account creation.
            </p>
            <p>
              This Data Processing Agreement (&ldquo;<strong>DPA</strong>
              &rdquo;) forms an integral part of the Agreement between Hourlee
              and the Employer governing access to and use of the Hourlee
              platform and services (the &ldquo;<strong>Main Agreement</strong>
              &rdquo;).
            </p>
            <p>
              This DPA applies whenever the Employer, in using the Hourlee
              Platform, receives or otherwise processes personal data that
              Hourlee collects, stores, or makes available in connection with
              the Platform for the purposes set out below.
            </p>
            <h2>
              <strong>1. Purpose &amp; Interpretation</strong>
            </h2>
            <p>
              1.1 <strong>Purpose</strong>
            </p>
            <p>
              This DPA sets out the parties&rsquo; roles and obligations with
              respect to the processing of personal data and is intended to
              ensure compliance with applicable data protection law, including
              but not limited to the General Data Protection Regulation (GDPR),
              where applicable, and other relevant national laws (including
              India&rsquo;s Digital Personal Data Protection Act, 2023, where
              applicable).
            </p>
            <p>
              1.2 <strong>Controller / Processor relationship</strong>
            </p>
            <p>
              For applicable data protection laws, Hourlee is the{" "}
              <strong>Data Fiduciary / Controller</strong> (it determines how
              and why personal data is processed on the Platform). The Employer
              is a <strong>Processor</strong> when it accesses or uses personal
              data from Hourlee&rsquo;s Platform or otherwise processes personal
              data of Job Seekers or persons whose data is made available via
              the Platform. The Employer shall process such personal data{" "}
              <strong>
                only on behalf of Hourlee and only in accordance with this DPA
                and Hourlee&rsquo;s documented instructions
              </strong>
              .
            </p>
            <p>
              1.3 <strong>References to Law &amp; Guidance</strong>
            </p>
            <p>
              The parties acknowledge that the obligations in this DPA are to be
              interpreted in light of applicable data protection legislation
              (e.g., GDPR and DPDPA) and supervisory guidance on controllers and
              processors.
            </p>
            <h2>
              <strong>2. Definitions</strong>
            </h2>
            <p>In this DPA:</p>
            <ul>
              <li>
                <strong>&ldquo;Personal Data&rdquo;</strong> means any
                information relating to an identified or identifiable natural
                person that is made available by Hourlee through the Platform or
                otherwise processed under the Main Agreement (including the
                categories set out in Schedule 1).
              </li>
              <li>
                <strong>&ldquo;Processing&rdquo;</strong> has the meaning given
                in applicable data protection laws and includes collection,
                recording, storage, retrieval, use, disclosure, erasure, and
                destruction.
              </li>
              <li>
                &ldquo;<strong>Data Fiduciary / Controller</strong>&rdquo; means
                RightO Services Private Ltd. (operating under the brand name
                Hourlee). This entity{" "}
                <strong>determines the purposes and means</strong> of the
                processing of Personal Data made available via the Platform. For
                the avoidance of doubt, the Data Fiduciary/Controller is
                responsible for establishing and documenting the lawful basis
                for processing, providing legally required notices to Data
                Subjects, and for compliance with applicable data protection law
                in respect of Personal Data processed through the Platform.
              </li>
              <li>
                &ldquo;<strong>Data Processor / Processor</strong>&rdquo; means
                the Employer (or other person or entity) that{" "}
                <strong>processes Personal Data on behalf of</strong> the Data
                Fiduciary / Controller in accordance with the Data
                Fiduciary&rsquo;s documented instructions and this Agreement.
                The Processor shall process Personal Data only for the Permitted
                Purpose and only in accordance with the Controller&rsquo;s
                instructions; shall implement appropriate technical and
                organisational measures; and shall comply with the obligations
                applicable to processors under applicable data protection law.
              </li>
              <li>
                <strong>&ldquo;Subprocessor&rdquo;</strong> means any third
                party engaged by the Employer to process Personal Data on behalf
                of Hourlee.
              </li>
              <li>
                <strong>&ldquo;Data Subject / Principal&rdquo;</strong> means
                the individual to whom Personal Data relates (e.g., Job Seekers,
                contact persons).
              </li>
              <li>
                <strong>Other capitalized terms</strong> used but not defined in
                this DPA have the meanings given in the Main Agreement.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>3. Roles and Responsibilities</strong>
            </h2>
            <p>
              3.1 <strong>Controller obligations (Hourlee)</strong>
            </p>
            <p>
              Hourlee remains responsible for determining the purposes and means
              of processing Personal Data and for compliance with the data
              protection obligations applicable to a Controller. Hourlee shall:
            </p>
            <ul>
              <li>
                Provide documented instructions to the Employer in relation to
                the Processing (these instructions are set out in the DPA, and
                the Schedules);
                <br />{" "}
              </li>
              <li>
                Ensure that it has lawful grounds and necessary notices/consents
                for the Processing required for the Employer to provide its
                services through the Platform; and
                <br />{" "}
              </li>
              <li>
                Implement appropriate safeguards, including ensuring the
                lawfulness of transfers, where necessary.
                <br />{" "}
              </li>
            </ul>
            <p>
              3.2 <strong>Processor obligations (Employer).</strong>
            </p>
            <p>&nbsp;The Employer shall:</p>
            <ul>
              <li>
                Process Personal Data only on written instructions from Hourlee
                (including the DPA), unless required to do otherwise by
                applicable law (in which case the Employer shall notify Hourlee
                in advance unless prohibited by law);
                <br />{" "}
              </li>
              <li>
                Not use Personal Data for any purpose other than those specified
                in Schedule 1 (the <strong>Permitted Purpose</strong>), nor
                combine, aggregate, or otherwise process Personal Data for its
                own independent purposes, and implement and maintain appropriate
                technical and organizational measures to protect Personal Data
                in accordance with Schedule 2;
                <br />{" "}
              </li>
              <li>
                Ensure that persons authorised to process Personal Data are
                bound by confidentiality obligations;
                <br />{" "}
              </li>
              <li>
                Assist Hourlee to comply with Data Subject rights requests,
                security incident response, DPIAs, and regulatory enquiries, as
                set out below;
                <br />{" "}
              </li>
              <li>
                Not permit any third party (other than Subprocessors authorised
                in accordance with clause 6) to process Personal Data; and
                <br />{" "}
              </li>
              <li>
                On termination or at Hourlee&rsquo;s request, delete or return
                Personal Data in accordance with clause 11.
                <br />{" "}
              </li>
            </ul>
            <p>
              3.3 <strong>Limitation of processing scope</strong>
            </p>
            <p>
              The Employer acknowledges and agrees that it has{" "}
              <strong>
                no right independently to access, use, disclose, or retain
                Personal Data for its own business purposes
              </strong>{" "}
              except to the extent expressly authorised in writing by Hourlee.
              Any use beyond the written instructions is a material breach of
              this DPA. The Employer will document all processing activities
              carried out on behalf of the Controller.
            </p>
            <h2>
              <strong>4. Details of Processing</strong>
            </h2>
            <p>
              4.1 <strong>Subject matter and duration</strong>
            </p>
            <p>
              The subject matter, nature, and duration of Processing, the types
              of Personal Data, and categories of Data Subjects are specified in{" "}
              <strong>Schedule 1</strong>.
            </p>
            <p>
              4.2 <strong>Permitted Purpose</strong>
            </p>
            <p>
              The Employer may process Personal Data only for the{" "}
              <strong>Permitted Purpose</strong> described in Schedule 1 (for
              example: evaluating candidates, arranging interviews, onboarding
              workers, facilitating payment, and verifying identity where
              necessary). Any extension of the Permitted Purpose requires
              Hourlee&rsquo;s prior written consent.
            </p>
            <p>
              4.3 <strong>Instructions</strong>
            </p>
            <p>
              The Employer shall follow Hourlee&rsquo;s documented instructions
              regarding Processing. If the Employer believes any instruction
              infringes applicable law, it must notify Hourlee promptly.
            </p>
            <h2>
              <strong>5. Security Measures</strong>
            </h2>
            <p>
              5.1 The Employer shall implement appropriate technical and
              organisational measures to protect Personal Data against
              accidental or unlawful destruction, loss, alteration, unlawful
              disclosure, or access, and to ensure a level of security
              appropriate to the risk. Such measures are set out in{" "}
              <strong>Schedule 2</strong> (minimum controls) and must at least
              include:
            </p>
            <ul>
              <li>
                Access controls and least-privilege;
                <br />{" "}
              </li>
              <li>
                encryption of Personal Data in transit and at rest, where
                feasible;
                <br />{" "}
              </li>
              <li>
                logging and monitoring of access;
                <br />{" "}
              </li>
              <li>
                vulnerability management and regular security testing;
                <br />{" "}
              </li>
              <li>
                secure development and change management practices;
                <br />{" "}
              </li>
              <li>
                incident detection, response, and recovery procedures; and
                <br />{" "}
              </li>
              <li>
                Personnel security (background checks and confidentiality
                obligations).
                <br />{" "}
              </li>
            </ul>
            <p>
              5.2 The Employer shall, at its cost, maintain reasonable and
              documented procedures to ensure secure storage and handling of any
              identity documents (e.g., PAN, GST, Aadhaar) and financial details
              used for payouts. The Employer must not store such documents
              beyond the periods required by law or for the Permitted Purpose.
            </p>
            <h2>
              <strong>6. Subprocessors</strong>
            </h2>
            <p>
              6.1 <strong>Authorisation</strong>
            </p>
            <p>
              The Employer shall not engage any Subprocessor to process Personal
              Data without Hourlee&rsquo;s prior written authorisation. Where
              Hourlee authorises Subprocessors, the Employer shall maintain a
              current list and promptly inform Hourlee of any proposed changes.
            </p>
            <p>
              6.2 <strong>Subprocessor obligations</strong>
            </p>
            <p>
              The Employer shall ensure any Subprocessor is bound by written
              contractual obligations that replicate the requirements of this
              DPA (including confidentiality, security, data subject assistance,
              and restrictions on onward transfers).
            </p>
            <p>
              6.3 <strong>Liability</strong>
            </p>
            <p>
              The Employer remains fully liable for the acts and omissions of
              its Subprocessors to the same extent the Employer would be liable
              if performing the processing itself.
            </p>
            <h2>
              <strong>7. Data Subject Rights &amp; Assistance</strong>
            </h2>
            <p>
              7.1 <strong>Data subject requests</strong>
            </p>
            <p>
              Where a Data Subject submits a request to the Employer (e.g.,
              access, rectification, erasure, portability, restriction,
              objection), the Employer shall promptly and in any event within 7
              business days notify Hourlee and shall not respond directly unless
              authorised to do so.
            </p>
            <p>
              &nbsp;The Employer shall provide Hourlee with all reasonably
              requested assistance to enable Hourlee to comply with Data Subject
              requests within the timeframes required by applicable law.
            </p>
            <p>
              7.2 <strong>Automation &amp; portability</strong>
            </p>
            <p>
              To the extent applicable, the Employer will support export of
              Personal Data in a structured, commonly used, machine-readable
              format to facilitate portability requests.
            </p>
            <h2>
              <strong>
                8. Personal Data Breach Notification &amp; Response
              </strong>
            </h2>
            <p>
              8.1 <strong>Notification</strong>
            </p>
            <p>
              The Employer shall notify Hourlee without undue delay and, where
              feasible, within 24 hours of becoming aware of any Personal Data
              Breach affecting Personal Data processed under this DPA, providing
              at least the information set out in Schedule 3 (initial details).
              Notification must be made to the Hourlee security contact set out
              in Schedule 1.
            </p>
            <p>
              8.2 <strong>Remedial action</strong>
            </p>
            <p>
              The Employer shall immediately take all reasonable steps to
              contain, investigate, mitigate, and remediate the breach and to
              prevent further unauthorised access, disclosure, or loss. The
              Employer shall cooperate with Hourlee and provide timely updates
              and such further information and assistance as Hourlee reasonably
              requests for fulfilling its breach notification obligations to
              supervisory authorities and Data Subjects under applicable law.
            </p>
            <p>
              8.3 <strong>Costs</strong>
            </p>
            <p>
              Unless otherwise agreed, each party shall bear its own costs for
              internal mitigation; however, where the Employer&rsquo;s failure
              or negligence caused the breach, the Employer shall bear
              reasonable incremental costs reasonably incurred by Hourlee in
              relation to investigation, notification, and remediation of the
              breach.
            </p>
            <h2>
              <strong>9. International Transfers</strong>
            </h2>
            <p>
              9.1 If the Employer or any of its Subprocessors transfers Personal
              Data outside the country/jurisdiction where the Data Subject is
              located, the Employer shall ensure such transfers comply with
              applicable Data Protection Law. For data originating in the
              EEA/UK, transfers require an appropriate transfer mechanism (e.g.,
              Standard Contractual Clauses, binding corporate rules, or
              adequacy). The Employer must not transfer such Personal Data
              without Hourlee&rsquo;s prior written consent and appropriate
              safeguards.
            </p>
            <p>
              9.2 The Employer shall promptly provide documentation of transfer
              safeguards upon Hourlee&rsquo;s request.
            </p>
            <h2>
              <strong>10. Audits and Inspections</strong>
            </h2>
            <p>
              10.1 <strong>Audit rights</strong>
            </p>
            <p>
              Hourlee (or an independent third-party auditor acting on
              Hourlee&rsquo;s behalf) may, on reasonable notice and subject to
              confidentiality controls, audit the Employer&rsquo;s compliance
              with this DPA (including inspection of relevant security
              documentation and systems) up to <strong>once per year</strong>{" "}
              during normal business hours, unless a significant breach is
              suspected, in which case immediate audit may be required.
            </p>
            <p>
              10.2 <strong>Practical arrangements</strong>
            </p>
            <p>
              The Employer shall reasonably cooperate and use commercially
              reasonable efforts to ensure audits do not unreasonably disrupt
              business operations. Hourlee will bear auditor costs unless an
              audit reveals material non-compliance by the Employer, in which
              case the Employer will reimburse Hourlee&rsquo;s reasonable audit
              costs.
            </p>
            <h2>
              <strong>11. Return, Deletion, and Retention</strong>
            </h2>
            <p>
              11.1 <strong>Return or deletion at termination</strong>
            </p>
            <p>
              Upon expiration or termination of the Main Agreement or upon
              Hourlee&rsquo;s instruction, the Employer shall, at
              Hourlee&rsquo;s election, either (a) return all Personal Data to
              Hourlee in a commonly used machine-readable format, and delete all
              other copies from its systems, or (b) securely delete or
              permanently anonymise all Personal Data in accordance with
              Schedule 4, unless retention is required by law. The Employer
              shall confirm in writing that it has complied with the return,
              deletion, or anonymisation.
            </p>
            <p>
              11.2 <strong>Retention for legal obligations</strong>
            </p>
            <p>
              If the Employer is required by law to retain Personal Data after
              termination, the Employer shall notify Hourlee in writing and
              limit access to those records solely to personnel who need access
              for legal compliance. Any retained Personal Data shall continue to
              be subject to the obligations of this DPA.
            </p>
            <h2>
              <strong>12. Confidentiality</strong>
            </h2>
            <p>
              12.1 The Employer shall treat all Personal Data as confidential
              and shall not disclose any Personal Data to any third party except
              as expressly permitted under this DPA or as authorised in writing
              by Hourlee.
            </p>
            <h2>
              <strong>13. Liability &amp; Indemnity</strong>
            </h2>
            <p>
              13.1 <strong>Indemnity</strong>
            </p>
            <p>
              The Employer shall indemnify, defend and hold harmless Hourlee
              from and against any loss, damage, cost, liability or expense
              (including reasonable legal fees) arising out of or resulting from
              any breach by the Employer of this DPA, including any unauthorised
              use, disclosure, or processing of Personal Data, or the
              Employer&rsquo;s failure to comply with applicable Data Protection
              Law.
            </p>
            <p>
              13.2 <strong>Limitations</strong>
            </p>
            <p>
              Nothing in this DPA limits either party&rsquo;s liability for (a)
              death or personal injury caused by negligence; (b) fraudulent
              misrepresentation; (c) breach of confidentiality obligations; (d)
              breaches of Data Protection Law involving willful misconduct or
              gross negligence; or (e) other liability that cannot be limited
              under applicable law.
            </p>
            <h2>
              <strong>14. Insurance</strong>
            </h2>
            <p>
              The Employer represents that it maintains appropriate cyber and
              data-privacy insurance coverage and will provide proof of such
              coverage upon Hourlee&rsquo;s reasonable request.
            </p>
            <h2>
              <strong>15. Termination</strong>
            </h2>
            <p>
              15.1 This DPA shall continue for the term of the Main Agreement.
              Upon termination of the Main Agreement, this DPA terminates except
              for surviving provisions required to give effect to obligations
              that by their nature survive (e.g., return/deletion obligations,
              confidentiality, indemnities).
            </p>
            <h2>
              <strong>16. Governing Law &amp; Dispute Resolution</strong>
            </h2>
            <p>
              16.1 This DPA shall be governed by and construed in accordance
              with the law specified in the Main Agreement. The parties shall
              seek to resolve disputes amicably. If not resolved, disputes shall
              be resolved in accordance with the dispute resolution provisions
              of the Main Agreement.
            </p>
            <h2>
              <strong>17. Miscellaneous</strong>
            </h2>
            <p>
              17.1 <strong>Amendments</strong>
            </p>
            <p>
              Any amendment to this DPA must be in writing and signed by
              authorised representatives of both parties.
            </p>
            <p>
              17.2 <strong>Severability</strong>
            </p>
            <p>
              If any provision of this DPA is held to be invalid or
              unenforceable, the remaining provisions shall remain in full force
              and effect.
            </p>
            <p>
              17.3 <strong>Order of precedence</strong>
            </p>
            <p>
              In the event of an inconsistency between this DPA Agreement, the
              DPA shall prevail with respect to data protection obligations,
              unless specifically stated otherwise in the Main Agreement.
            </p>
            <h2>
              <strong>SCHEDULE 1 - DETAILS OF PROCESSING</strong>
            </h2>
            <ol>
              <li>
                <strong> Parties</strong>
              </li>
            </ol>
            <ul>
              <li>
                <strong>Data Fiduciary / Controller:</strong> RightO Services
                Private Ltd. (Hourlee), 52/1 Park Road, Dehradun &ndash; 248001,
                India. Contact: Privacy@hourlee.in.
                <br />{" "}
              </li>
              <li>
                <strong>Processor:</strong> Employer (name and address as set
                out in the Account).
                <br />{" "}
              </li>
            </ul>
            <ol>
              <li>
                <strong> Processing Description</strong>
              </li>
            </ol>
            <ul>
              <li>
                <strong>Subject matter:</strong> Candidate recruitment and
                related platform services (job posting, candidate communication,
                applications, onboarding, payments).
                <br />{" "}
              </li>
              <li>
                <strong>Duration:</strong> For the term of the 1 year and
                thereafter as required for deletion/retention obligations.
                <br />{" "}
              </li>
              <li>
                <strong>Nature &amp; Purpose:</strong> To enable Employers to
                advertise vacancies, receive and evaluate applications,
                communicate with applicants, verify identity/credentials (as
                needed), manage engagements and payouts.
                <br />{" "}
              </li>
              <li>
                <strong>Categories of Personal Data:</strong> As Collected Via
                Hourlee Platforms, Including But Not Limited To: Userid, Name,
                Phone Number, Alternate Phonenumber, Email, Image, Date Of
                Birth, Gender, Address/State/City/Pincode, Job Profile,
                Industrytype, Pan Card Number, Gst Number And Certificate
                Uploads, Resume, Skills, Experience, Application History,
                Payment/Payout Details, Job Post Fields (Jobtitle, Job
                Description, Salary Type, Min Salary, Max Salary, Work Mode,
                Phone Number/Email), And Platform Metadata.
                <br />{" "}
              </li>
              <li>
                <strong>Categories of Data Subjects:</strong> Job Seekers,
                contact persons at Employers, applicants, and other users of the
                Platform.
                <br />{" "}
              </li>
            </ul>
            <ol>
              <li>
                <strong> Hourlee Instructions</strong>
              </li>
            </ol>
            <ul>
              <li>
                Employer shall process Personal Data strictly to perform the
                Permitted Purpose and under Hourlee&rsquo;s documented
                instructions.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>
                SCHEDULE 2 - MINIMUM TECHNICAL &amp; ORGANISATIONAL MEASURES
              </strong>
            </h2>
            <p>
              Employer must implement, at a minimum, the following: Hourlee may
              require higher standards depending on risk.
            </p>
            <ol>
              <li>
                Access control and identity management (multi-factor for
                privileged accounts).
                <br />{" "}
              </li>
              <li>
                Encryption in transit (TLS 1.2+) and at rest (industry-standard
                algorithms such as AES-256 where feasible).
                <br />{" "}
              </li>
              <li>
                Logical separation and least privilege access.
                <br />{" "}
              </li>
              <li>
                Logging and monitoring of access and administrative actions.
                <br />{" "}
              </li>
              <li>
                Regular vulnerability scanning and annual penetration testing.
                <br />{" "}
              </li>
              <li>
                Secure software development lifecycle and patch management.
                <br />{" "}
              </li>
              <li>
                Regular data backups and secure off-site storage with recovery
                testing.
                <br />{" "}
              </li>
              <li>
                Incident response plan with notification timelines aligned to
                clause 8.
                <br />{" "}
              </li>
              <li>
                Employee confidentiality obligations and background checks for
                personnel with access.
                <br />{" "}
              </li>
              <li>
                Data minimization, retention schedule, and secure deletion
                methods.
                <br />{" "}
              </li>
            </ol>
            <p>
              Employer shall provide evidence of compliance upon reasonable
              request.
            </p>
            <h2>
              <strong>SCHEDULE 3 - BREACH NOTIFICATION CONTENT </strong>
            </h2>
            <p>
              In the event of a Personal Data Breach, the Employer shall
              include, where available and appropriate:
            </p>
            <ul>
              <li>
                Description of the nature of the incident and likely
                consequences;
                <br />{" "}
              </li>
              <li>
                categories and estimated number of data subjects and personal
                data records affected;
                <br />{" "}
              </li>
              <li>
                categories of personal data affected (e.g., contact details,
                identity docs, financial info);
                <br />{" "}
              </li>
              <li>
                measures taken or proposed to contain and mitigate the breach;
                <br />{" "}
              </li>
              <li>
                contact point for further information; and
                <br />{" "}
              </li>
              <li>
                Any other information reasonably requested by Hourlee or
                required by applicable law.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>
                SCHEDULE 4 -&nbsp; RETURN, DELETION &amp; ANONYMISATION
              </strong>
            </h2>
            <ul>
              <li>
                <strong>Return:</strong> Standard CSV/JSON export of structured
                data fields.
                <br />{" "}
              </li>
              <li>
                <strong>Deletion:</strong> Secure deletion within one year using
                industry-standard methods (e.g., NIST 800-88 guidelines).
                <br />{" "}
              </li>
              <li>
                <strong>Anonymisation:</strong> Irreversible transformation such
                that data cannot be attributed to an identifiable person using
                reasonable means.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>SIGNATURES</strong>
            </h2>
            <p>By signing below, the parties agree to be bound by this DPA.</p>
            <p>
              <strong>
                RightO Services Private Ltd. (Hourlee)
                <br />{" "}
              </strong>
              &nbsp;Signature: <br /> &nbsp;Name: Jagmohan singh
              <br /> &nbsp;Title: Director
              <br /> &nbsp;Date: 11 Dec 2026
            </p>
            <p>
              <strong>
                Employer
                <br />{" "}
              </strong>
              &nbsp;Signature: ___________________________
              <br /> &nbsp;Name: ______________________________
              <br /> &nbsp;Title: _______________________________
              <br /> &nbsp;Date: _______________________________
            </p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default DataProcessing;
